import { Container } from '@bit/ui-common.ui-components/ss-components';
import { injectLinkConfig } from '../../../utils/helpUtils';
import HelpData from '@bit/ui-common.ui-components/ss-common-data/react/components/help/HelpData';
import { getPathParams } from '@bit/ui-common.ui-components/ss-utils/utils/commonUtils';

const id = 'afsp-help-regulatory-information';

export default Container({
    state: s => ({ commonData: s.commonData }),
    services: []
},
    class Regulatory extends React.Component {
        constructor(props) {
            super(props);
        }
        componentDidMount() { injectLinkConfig(id); }

        render() {
            const { space, theme } = this.props;
            let namedDest;

            const params = getPathParams();
            if (params != null && params.namedDest != null) {
                namedDest = params.namedDest;
            }

            return (
                    <HelpData
                        title={'Regulatory Information'}
                        space={space || null}
                        theme={theme || null}
                        pdfs={[]}
                        defaultPdf={'/home/AboutTheRegulation.pdf'}
                    />
            )
        }
    })
